import React from "react";
import { FiInbox } from "react-icons/fi";

const NoData = ({ title = "Nenhum registro encontrado", description = "Não há dados para exibir aqui.", icon: Icon = FiInbox, children }) => {
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "2rem 1rem",
      background: "#fff",
      borderRadius: "1.2rem",
      border: "1px solid #dcdcdc",
      margin: "1rem 0"
    }} className="shadow-sm">
      <div style={{
        background: "#f3f4f6",
        borderRadius: "50%",
        padding: "1.2rem",
        marginBottom: "1.2rem"
      }}>
        <Icon size={38} color="#f43f5e" />
      </div>
      <h3 style={{ margin: 0, fontWeight: 700, fontSize: "1.2rem", color: "#374151" }}>{title}</h3>
      <p style={{ margin: "0.5rem 0 0.5rem 0", color: "#6b7280", fontSize: "1rem" }}>{description}</p>
      {children}
    </div>
  );
};

export default NoData;
